export default "__VITE_ASSET__Q$QFV3vF__"